import request from '@/utils/request'

/**
 * 查询家政服务人员列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingServUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServUser/queryHousekeepingServUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存家政服务人员
 * @param {Object} data 保存数据
 * @returns {Promise} Promise对象
 */
export function saveHousekeepingServUser(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServUser/saveHousekeepingServUser',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除家政服务人员
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteHousekeepingServUser(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServUser/deleteHousekeepingServUser',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}